const interactAgentTaskEvents = {
  AnswerQuestions: 'answer_questions',
  UpdateDataFromResponse: 'update_data_from_response',
  addDocument: 'addDocument',
  createTask: 'createTask',
  getLatestTasks: 'getLatestTasks',
  getTaskById: 'getTaskById',
  refreshTasks: 'refreshTasks',
  taskClassify: 'task-classify',
  taskReportIncident: 'task-reportIncident',
  taskRetryPage: 'task-retryPage',
  restart: 'restart'
};

export default interactAgentTaskEvents;
